import { SkeletalData } from "../../../lib/types/statsApi";
import { PoserClock } from "../../util/clock";
import { WorkerContext } from "../context";
import { ManifestLimits } from "../TrackingDataManager";

export interface WorkerInit {
  type: "init";
  data: {
    context: WorkerContext;
    clock: PoserClock;
  };
}

export interface WorkerInitReturn {
  type: "return-init";
  data: ManifestLimits | undefined;
}

export interface WorkerTeardown {
  type: "teardown";
}

export interface WorkerUpdate {
  type: "update";
  data: {
    clock: PoserClock;
    lastFrameNum?: number;
    lowTrackingFps: boolean;
  };
}

export interface WorkerSetToken {
  type: "set-token";
  data: {
    token: string;
  };
}

export interface WorkerGetTimeLimits {
  type: "get-time-limits";
}

export interface WorkerGetTimeLimitsReturn {
  type: "return-get-time-limits";
  data: ManifestLimits | undefined;
}

export interface UpdateReturnData {
  chunk: SkeletalData;
  chunkIndex: number;
  debugIndex: number;
}
export interface WorkerUpdateReturn {
  type: "return-update";
  data: UpdateReturnData;
}

export type WorkerMsg =
  | WorkerInit
  | WorkerTeardown
  | WorkerUpdate
  | WorkerSetToken
  | WorkerGetTimeLimits
  | WorkerInitReturn
  | WorkerUpdateReturn
  | WorkerGetTimeLimitsReturn;

// TODO: deprecate these and use the tracking ArrayBuffer directly in the rendering code
export function serialise(msg: WorkerMsg): ArrayBuffer {
  const string = JSON.stringify(msg);
  const array = new TextEncoder().encode(string);
  return array.buffer;
}

export function deserialise(buffer: ArrayBuffer): WorkerMsg {
  const string = new TextDecoder().decode(buffer);
  const msg = JSON.parse(string);
  return msg;
}
